import { types } from 'mobx-state-tree';


const ROOF_TYPES = {
    ASPHALT: 'asphalt',
    CLAY_TILE: 'clay-tile',
    CONCRETE: 'concrete',
    COPPER: 'copper',
    RUBBER: 'rubber',
    SLATE_TILE: 'slate-tile',
    STEEL: 'steel',
    TAR_AND_GRAVEL: 'tar-and-gravel',
    TIN: 'tin',
    WOOD_SHINGLES: 'wood-shingles',
};

const RoofTypeEnum = types.enumeration('RoofType', Object.values(ROOF_TYPES));

export {
    RoofTypeEnum,
};
export default ROOF_TYPES;
